import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

import { useCurrentUser } from '@savgroup-front-common/core/domains/login/useLoginStore';
import { useToasts } from '@savgroup-front-common/core/molecules/NotificationsProvider';

import { OwnerService } from '@/api';
import useGetClientInformation from '@/view/app/hooks/useGetClientInformation';

import { adaptSearchOrderDetails } from '../adapters/adaptSearchOrderDetails';

export const GET_BUSINESS_RETURN = 'getBusinessReturn';

export const useGetBusinessReturn = () => {
  const { orderReference } = useParams<{ orderReference: string }>();
  const { clientInformation } = useGetClientInformation();

  const { pushErrors } = useToasts();
  const { id: ownerId } = useCurrentUser();

  const { data, isLoading } = useQuery(
    [
      GET_BUSINESS_RETURN,
      { sellerId: clientInformation?.sellerId, orderReference, ownerId },
    ],
    async () => {
      if (!clientInformation?.sellerId || !orderReference) {
        return undefined;
      }

      const response = await OwnerService.startOrContinueBusinessReturnCommand({
        ownerId,
        sellerId: clientInformation?.sellerId,
        orderReference,
      });

      if (response.failure) {
        pushErrors(response.errors);

        return undefined;
      }

      return response.value;
    },
    { enabled: !!orderReference, staleTime: Infinity },
  );

  return {
    order: adaptSearchOrderDetails(data?.order),
    eligibility: data?.eligibility,
    isLoading,
  };
};
